module.exports = __webpack_public_path__ + "img/kommune-1725.59fae652.svg";